import { Component, Input } from '@angular/core';
import { AccountOptionOffer } from '../../../entities/account-option-offer.entity';
import { AccountOption } from '../../../entities/account-option.entity';
import { UserService } from '../../../services/user.service';
import { User } from '../../../entities/index';


@Component({
  selector: 'app-linked-account-options',
  templateUrl: './linked-account-options.html'
})
export class AccountOptionComponent {
  _user: User
  accountOptions: AccountOption[] = []
  loading = false;


  constructor(protected userService: UserService) { }

  mapAccountOptionOfferToOption = (offer: AccountOptionOffer): AccountOption => {
    const account_option_in_db = this._user.account_options.find((account_option) => account_option.code == offer.code)
    if (account_option_in_db === undefined) {
      const accountOption: AccountOption = {
        id: null,
        activated: false,
        activation_date: null,
        amount: offer.price_offer.fr.amount,
        created_at: null,
        currency: null,
        is_running: null,
        next_charge_at: null,
        code: offer.code,
        user_id: this._user.id,
      }
      return accountOption;
    }
    const accountOption: AccountOption = {
      id: account_option_in_db.id,
      activated: account_option_in_db.activated,
      activation_date: account_option_in_db.activation_date,
      amount: account_option_in_db.amount,
      created_at: account_option_in_db.created_at,
      currency: account_option_in_db.currency,
      is_running: account_option_in_db.is_running,
      next_charge_at: account_option_in_db.next_charge_at,
      code: account_option_in_db.code,
      user_id: this._user.id,
    }
    return accountOption;
  }

  initAccountOption = () =>
    this._user.account_option_offers.forEach((offer) => {
      this.accountOptions.push(
        this.mapAccountOptionOfferToOption(offer)
      )
    })

  @Input()
  set user(user: User) {
    this._user = user;
    this.loading = true;
    if (user.account_option_offers) {
      this.loading = false;
      this.initAccountOption()
    }
  }

  toggleOption = (optionCode: string) => {
    const matchedOption = this.accountOptions.find((option) => option.code === optionCode);
    if (matchedOption !== undefined) {
      matchedOption.activated = !matchedOption.activated;
    }
    // TODO Call API endpoint when backend is ready
    // You may uncomment below code when backend is ready.

    // this.userService.modifyAccountOptions(
    //   this._user.id,
    //   this.accountOptions.filter((option) => option.activated)
    // )
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/blocks/linked-account-options/linked-account-options.component.ts